jQuery(document).ready(function () {

    // Only run if countdown container exists
    if (!$('.countdown-container').length) {
        return;
    }

    let targetDate;
    let countdownFunction;

    function startCountdown(date) {
        clearInterval(countdownFunction);

        targetDate = new Date(date).getTime();

        countdownFunction = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            // Stop if invalid date
            if (isNaN(distance)) {
                clearInterval(countdownFunction);
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            document.getElementById("newDays").innerText = String(days).padStart(2, '0');
            document.getElementById("newHours").innerText = String(hours).padStart(2, '0');
            document.getElementById("newMinutes").innerText = String(minutes).padStart(2, '0');
            document.getElementById("newSeconds").innerText = String(seconds).padStart(2, '0');

            if (distance < 0) {
                clearInterval(countdownFunction);

                // Add 1 day and restart
                targetDate += 24 * 60 * 60 * 1000;
                startCountdown(new Date(targetDate));
            }

        }, 1000);
    }

    // var end_date = '{{ end_date }}';
    var end_date = 'May 28, 2026 23:59:59';

    startCountdown(end_date);

});